import { render } from "./SettingsCreate.vue?vue&type=template&id=65cc3b33&scoped=true"
import script from "./SettingsCreate.vue?vue&type=script&lang=js"
export * from "./SettingsCreate.vue?vue&type=script&lang=js"

import "./SettingsCreate.vue?vue&type=style&index=0&id=65cc3b33&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65cc3b33"]])

export default __exports__